import { defineStore } from "pinia";
import { ref } from "vue";

export const useInsightsStore = defineStore("insights", () => {
  const openSidebar = ref<boolean>(true);
  const search = ref<string>("");
  const insightsPageHeaderHeight = ref<number>(0);

  function reset(): void {
    search.value = "";
  }

  return {
    insightsPageHeaderHeight,
    openSidebar,
    reset,
    search,
  };
});

export default useInsightsStore;
